import React from "react";
import { useParams } from "react-router-dom";
import Header from "../../layout/Header";
import PrivacyConsentContent from "./PrivacyConsentContent";
import { getPrivacyConsentNotice } from "../../../content/privacyConsentNotice";

export const PrivacyConsentNotice = () => {
  const { lang } = useParams();
  const notice = getPrivacyConsentNotice(lang);

  return (
    <>
      <Header />
      <div className="main">
        <div className="container p-0">
          <div className="card border-0">
            <div className="card-body px-3 py-3">
              <h5 className="programDetailsText mb-3">{notice.title}</h5>
              <PrivacyConsentContent lang={lang} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
